module.exports = __webpack_public_path__ + "static/img/home_our products_PVC.7641225f.jpg";